// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"Spinner_spinnerOverlay__1K8kW","spinner":"Spinner_spinner__3iM_m","spin":"Spinner_spin__2mSsb"};